import { TableCell, TableHead, TableRow } from "@mui/material";

import { SETTLEMENT_STYLES } from "../../style/styles";

export default function OtherLiensBalanceTableHeader({ showActions = true }) {
  return (
    <TableHead>
      <TableRow sx={SETTLEMENT_STYLES.singleSelectHeaderRow}>
        <TableCell className="font-bold">Label</TableCell>
        <TableCell className="font-bold">Amount</TableCell>
        <TableCell className="font-bold">Deducted From</TableCell>
        {showActions ? (
          <TableCell className="font-bold" align="right">
            &nbsp;
          </TableCell>
        ) : null}
      </TableRow>
    </TableHead>
  );
}
